module.exports = __webpack_public_path__ + "img/1d48f798-9aa6-44f5-b019-984f4456c72b.6a1331ba.jpg";